import styled from 'styled-components';
import Pagination from '@mui/material/Pagination';

export const Main = styled.main`
    padding: 80px 16.66666666666667% 180px;
`;

export const PageButton = styled(Pagination)`
    margin-top: 70px;
    display: flex;
    justify-content: center;
`;
